export const fmtTC = (t) => {
  if (t == null) return "";
  const v = Math.max(0, Math.floor(t));
  const h = Math.floor(v / 3600);
  const m = Math.floor((v % 3600) / 60);
  const p = (n) => String(n).padStart(2, "0");
  return h ? `${h}:${p(m)}:${p(v % 60)}` : `${p(m)}:${p(v % 60)}`;
};

// "3:12", "1:03:12" or "192" -> seconds; "" -> null; invalid -> NaN
export const parseTC = (val) => {
  const s = String(val || "").trim();
  if (!s) return null;
  if (!/^\d+(:\d{1,2}){0,2}$/.test(s)) return NaN;
  return s.split(":").reduce((a, x) => a * 60 + Number(x), 0);
};

export const streamUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/drive/stream/${id}`;
export const PLAYABLE = ["video/mp4", "video/webm"];
